import React from 'react'
import range from 'lodash.range'

import { SelectInput, SelectInputOption, SelectInputProps } from '../SelectInput'

const currentYear: number = new Date().getFullYear()

export interface YearInputProps extends Omit<SelectInputProps, 'order'> {
  startYear?: number
  numberOfYears?: number
  endYear?: number
  order?: 'ascending' | 'descending'
}

export const YearInput = ({
  startYear = currentYear,
  endYear,
  numberOfYears = 10,
  order = 'ascending',
  ...restProps
}: YearInputProps) => {
  const totalYears = endYear ? startYear - endYear : numberOfYears

  const years: SelectInputOption[] = range(totalYears).map(num => {
    const year = order === 'descending' ? -num : num

    return {
      label: String(startYear + year),
      value: startYear + year,
    }
  })

  return <SelectInput {...restProps} options={years} />
}

export default YearInput
